import { CountryItem } from './countryTypes'
import { filterAndSortFields } from './../identifyUtils.ts'
import {
  nationalId,
  nationalIdSweden,
  email,
  phonenumber,
  firstName,
  lastName,
  address1,
  address2,
  zip,
  city } from './../identifyFields.ts'
import { bankId, frejaId, manual } from './../providers/index.ts'

export const sweden: object = (fieldsToInclude, KYCFields = false): CountryItem => {
  let fields = [
    {
      ...nationalId,
      ...nationalIdSweden
    },
    email,
    phonenumber,
    firstName,
    lastName,
    address1,
    address2,
    zip,
    city
  ]
  const providers = [
    bankId,
    frejaId,
    manual
  ]
  const settings = {
    rememberDevice: true, // should it be an opt in or opt out
    storeData: true // should it be an opt in or opt out
  }
  if (fieldsToInclude) {
    // filter out based on the passed in fields and only returned the matching ones
    fields = filterAndSortFields(fields, fieldsToInclude)
  } else if (KYCFields) {
    fields = fields.filter(field => field.includeInKYC === undefined || field.includeInKYC === true) // Don't include fields we only use in the identity wizard
  }

  return {
    fields,
    providers,
    settings
  }
}
